import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../../InputForm';
import SelectForm from '../../SelectForm';
import SelectMultiForm from '../../SelectMultiForm';
import InputMultiImage from '../../imagenes_multi_componente/InputMultiImage';
import usePlatillosStore from '../../../store/platilloStore';

const FormPlatillo = () => {
    const { datos, categoriasPlatillo, sucursales, sucursalesPlatillo, nivel_de_picante, multiImagenes, handleChangeImagen, handleChange, handleSave, handleSucursales, estatus, error, handleEsNuevo } = usePlatillosStore();
    const navigate = useNavigate();
    const [disabledButton, setDisabledButton] = useState(false)
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <SelectForm
                        col="col-sm-12"
                        name='id_cp'
                        label='Categoría'
                        datos={datos}
                        change={handleChange}
                        error={error}
                        options={categoriasPlatillo}
                        required
                    />
                    <InputForm
                        name="descripcion"
                        label="Descripción"
                        datos={datos} 
                        change={handleChange}
                        error={error}
                        required/>
                    {/* <PrincipalCroopImagen
                        laimagen={datos.imagen} // imagen que viene de la base de datos
                        handleChangeImagen={handleChangeImagen} // funcion para cambiar la imagen
                        currentPage={currentPage} // pagina actual
                        setcurrentPage={setcurrentPage} // funcion para cambiar la pagina
                    /> */}
                    <InputMultiImage
                        label="Imágenes"
                        multiImagenes={multiImagenes}
                        handleChangeImagen={handleChangeImagen}
                        name="multiImagenes"
                        errores={error}
                    />
                    <InputForm
                        name="precio"
                        label="Precio"
                        esNumeroConDecimales={true}
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    {/* <SelectForm
                        name='nivel_picante'
                        label='Nivel Picante'
                        datos={datos}
                        change={handleChange}
                        options={nivel_de_picante}
                    /> */}
                    <div className="form-switch switch-primary d-flex align-items-center gap-2 mt-2 mb-4 mx-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch1"
                            defaultChecked={datos.es_nuevo}
                            onChange={(e) => handleEsNuevo(e.target.checked)}
                        />
                        <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                            htmlFor="switch1"
                        >
                            ¿Es Nuevo?
                        </label>
                    </div>
                    {/* <InputForm
                        name="tiempo"
                        label="Tiempo de Preparación (en minutos)"
                        esNumero={true}
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/> */}
                    <SelectMultiForm
                        col="col-sm-12"
                        datos={sucursales} 
                        change={handleSucursales}
                        values={sucursalesPlatillo}
                        placeholder="Seleccione una o varias sucursales"
                        name="sucursalesPlatillo"
                        isMulti={false}
                        error={error}
                    />
                    <SelectForm
                        name='estatus'
                        label='Estatus'
                        datos={datos}
                        change={handleChange}
                        error={error}
                        options={estatus}
                    />
                    
                    
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <div>
                            <button
                                onClick={goBack}
                                type="reset"
                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                            >
                                Cancelar
                            </button>

                        </div>
                        <button
                            // type="submit"
                            disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormPlatillo;
